import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useForkRef } from '@cian/react-utils';
import { invoke } from '../../../internal/utils/invoke';
import { DropdownPopover } from '../../../popover';
import { DateInputInput } from '../../internal/components/DateInputInput';
import { CalendarPicker } from '../../internal/components/CalendarPicker';
import { useDateLimitValue } from '../../internal/hooks';
import { useTimeout } from '../../../internal/hooks';
import { formatDateValueToHTML } from '../../internal/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const DateInputDesktop = /*#__PURE__*/React.forwardRef(function DateInputDesktop(props, ref) {
  const [open, setOpen] = React.useState(false);
  const inputRootRef = React.useRef(null);
  const handleRef = useForkRef(ref, inputRootRef);
  const maskInputRef = React.useRef(null);
  const handleMaskInputRef = useForkRef(maskInputRef, props.maskInputRef);
  const dropdownFocusedRef = React.useRef(false);
  const min = useDateLimitValue(props.min);
  const max = useDateLimitValue(props.max);
  const disabledDates = props.disabledDates ? props.disabledDates.map(useDateLimitValue) : undefined;
  const inputFocusTimeout = useTimeout();
  const inputBlurTimeout = useTimeout();
  const dropdownBlurTimeout = useTimeout();
  const openDropdown = () => {
    if (props.readOnly || props.disabled) {
      return;
    }
    setOpen(true);
  };
  const closeDropdown = () => {
    setOpen(false);
  };
  const handleInputClick = e => {
    invoke(props.onClick, e);
    if (!e.defaultPrevented) {
      openDropdown();
    }
  };
  const handleInputFocus = e => {
    e.persist();
    dropdownBlurTimeout.clear();
    inputFocusTimeout.set(() => {
      const dropdownHaveFocused = dropdownFocusedRef.current;
      dropdownFocusedRef.current = false;
      openDropdown();
      if (!dropdownHaveFocused) {
        invoke(props.onFocus, e);
      }
    }, 0);
  };
  const handleInputBlur = e => {
    e.persist();
    inputBlurTimeout.set(() => {
      if (dropdownFocusedRef.current) {
        return;
      }
      closeDropdown();
      invoke(props.onBlur, e);
    }, 0);
  };
  const handleDropdownFocused = e => {
    e.preventDefault();
    dropdownFocusedRef.current = true;
    const input = maskInputRef.current;
    input === null || input === void 0 || input.focus();
  };
  const handleDropdownBlur = () => {
    dropdownBlurTimeout.set(() => {
      dropdownFocusedRef.current = false;
      // Вызываем чуть позже, чтобы обработать фокус на инпуте первым
    }, 10);
  };
  const handleChange = nextDate => {
    if (formatDateValueToHTML(props.value) !== formatDateValueToHTML(nextDate)) {
      invoke(props.onChange, nextDate);
    }
    closeDropdown();
  };
  return /*#__PURE__*/_jsx(DropdownPopover, {
    open: open,
    sameWidth: false,
    content: /*#__PURE__*/_jsx("div", {
      tabIndex: 0,
      onFocus: handleDropdownFocused,
      onBlur: handleDropdownBlur,
      children: /*#__PURE__*/_jsx(CalendarPicker, {
        selected: props.value || null,
        onChange: handleChange,
        min: min,
        max: max,
        disabledDates: disabledDates
      })
    }),
    children: /*#__PURE__*/_jsx(DateInputInput, _objectSpread(_objectSpread({}, props), {}, {
      ref: handleRef,
      onFocus: handleInputFocus,
      onBlur: handleInputBlur,
      onClick: handleInputClick,
      maskInputRef: handleMaskInputRef,
      min: min,
      max: max
    }))
  });
});